import type { FilterProps } from '../../Filters';
import { Attention } from '@fabric-ds/react';

const valueToBoolean = (value) => {
    if (typeof value === 'boolean') {
        return value;
    }
    if (typeof value === 'string') {
        return value !== 'false';
    }
    return Boolean(value);
};

export const TransactionalFilter = ({ filters, onFilterChanged }: FilterProps) => (
    <div className="input-toggle">
        <input
            id="transactional"
            type="checkbox"
            checked={valueToBoolean(filters.is_transactional)}
            onChange={(event) => onFilterChanged({ is_transactional: event.target.checked })}
        />
        <label htmlFor="transactional">
            <span>Enkel bestilling</span>
        </label>
        <Attention callout placement="bottom" isShowing={true} className="pt-16">
            <p>
                <span className="font-bold">Nyhet!</span> Lei feriehjem i Norge med enkel betaling via FINN.
            </p>
        </Attention>
    </div>
);
